import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card } from "@/components/ui/card";

interface OfferPageDetailsFormProps {
  title: string;
  setTitle: (title: string) => void;
  description: string;
  setDescription: (description: string) => void;
  heading: string;
  setHeading: (heading: string) => void;
  onClose: () => void; // Add this
}

const OfferPageDetailsForm: React.FC<OfferPageDetailsFormProps> = ({
  title,
  setTitle,
  description,
  setDescription,
  heading,
  setHeading,
  onClose, // Add this
}) => {
  return (
    <div>
     
      <div className="px-4 sm:px-6">
        <Card className="p-6 mb-4 bg-[#F2F2F2]">
          <h2 className="text-lg font-medium mb-4">Checkout Page Details</h2>
          <div className="space-y-4">
            <div>
              <Label htmlFor="heading">Heading</Label>
              <Input
                id="heading"
                placeholder="e.g. Summer Savings Event"
                value={heading}
                onChange={(e) => setHeading(e.target.value)}
                required
              />
            </div>
            <div>
              <Label htmlFor="description">Description</Label>
              <Textarea
                id="description"
                placeholder="e.g. Get amazing deals this summer!"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default OfferPageDetailsForm;